/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import JSG from '@cedalo/jsg-ui';
import { FormattedMessage } from 'react-intl';
import { graphManager } from '../../../GraphManager';
import Divider from '@mui/material/Divider';
import DialogButton from '../../utils/DialogButton';

export default class DeleteCellsDialog extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			open: false,
			type: 'cellshorizontal'
		};

		this.handleClose = this.handleClose.bind(this);
	}

	componentDidMount() {
		JSG.NotificationCenter.getInstance().register(
			this,
			JSG.WorksheetView.SHEET_ACTION_NOTIFICATION,
			'onSheetAction'
		);
	}

	componentWillUnmount() {
		JSG.NotificationCenter.getInstance().unregister(this, JSG.WorksheetView.SHEET_ACTION_NOTIFICATION);
	}

	onSheetAction(notification) {
		if (notification.object) {
			// const item = notification.object.view.getItem();
			if (notification.object.action === 'deletecells') {
				this.setState({ open: true });
			}
		}
	}

	handleCancel = () => {
		this.setState({ open: false });
	};

	handleClose = () => {
		this.setState({ open: false });

		const sheetView = graphManager.getActiveSheetView();

		if (sheetView) {
			sheetView.deleteCells(graphManager.getGraphEditor().getGraphViewer(), this.state.type);
		}
	};

	render() {
		if (!this.state.open) {
			return null;
		}
		return (
			<div>
				<Dialog open={this.state.open}>
					<DialogTitle>
						<FormattedMessage id="DeleteCellsDialog.Title" defaultMessage="Delete Cells" />
					</DialogTitle>
					<DialogContent>
						<RadioGroup
							name="type"
							value={this.state.type}
							onChange={(event, state) => {
								this.setState({ type: state });
							}}
							style={{
								marginTop: '20px'
							}}
						>
							<FormControlLabel
								value="cellshorizontal"
								control={<Radio />}
								label={<FormattedMessage id="DeleteCellsDialog.MoveLeft" defaultMessage="Move Left" />}
							/>
							<FormControlLabel
								value="cellsvertical"
								control={<Radio />}
								label={<FormattedMessage id="DeleteCellsDialog.MoveTop" defaultMessage="Move Top" />}
							/>
							<FormControlLabel
								value="rows"
								control={<Radio />}
								// eslint-disable-next-line
								label={
									<FormattedMessage id="DeleteCellsDialog.DeleteRows" defaultMessage="Delete Rows" />
								}
							/>
							<FormControlLabel
								value="columns"
								control={<Radio />}
								// eslint-disable-next-line
								label={
									<FormattedMessage
										id="DeleteCellsDialog.DeleteColumns"
										defaultMessage="Delete Columns"
									/>
								}
							/>
						</RadioGroup>
					</DialogContent>
					<Divider />
					<DialogActions>
						<DialogButton margin onClick={this.handleCancel}>
							<FormattedMessage id="Dialog.Cancel" defaultMessage="Cancel" />
						</DialogButton>
						<DialogButton margin onClick={this.handleClose} defaultButton>
							<FormattedMessage id="Dialog.OK" defaultMessage="OK" />
						</DialogButton>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}
